import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import { MdOutlinePeople ,MdFactCheck} from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
  getFacultyClassData,
  clearErrorStatusCode,
  clearErrorMessage,
  clearClassData,
  getTermData,
  updateParmsForClass,
  getClassRosterData,
} from "../../../../reduxSlices/classesSlice";

import { isObjectEmpty } from "../../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../../reduxSlices/loginSlice";
import Backdrop from "../../../Backdrop";
import Aux from "../../../../hoc/Auxilliary";
import MessageIndicator from "../../../SnackBar";
import localizedStrings from "../../../../utils/localize";
import Attendance from "../Attendance";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
});

function PageConatiner(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [termsData, setTerms] = useState("");
  const [filterTermsData, setfilterTermsData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [status, setStatus] = useState("");
  const [studentId, setStudentId] = useState(undefined);
  const [displayMessage, setDisplayMessage] = useState("");
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [modalTableMapData, setModalTableMapData] = useState([]);


  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const [tableMapData, setTableMapData] = useState([]);

  const classData = useSelector((state) => state.classData.classData);
  const terms = useSelector((state) => state.classData.terms);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const errorMessage = useSelector((state) => state.classData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.classData.errorStatusCode,
  );

  useEffect(() => {
    dispatch(
      getFacultyClassData(window.localStorage.getItem("x-auth-contactId")),
    );
    dispatch(getTermData());
  }, [dispatch]);

  useEffect(() => {
    if (applicantStatus.ses_applicantstatus) {
      setStudentId(applicantStatus.ses_applicantstatus.ses_studentid);
    }
  }, [applicantStatus]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = event?.target?.value;
    if (value == null) {
      return;
    }
    setRowsPerPage(+value);
    setPage(0);
  };

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
  };
  const handleUpdate = (e, sessionId) => {
    e.preventDefault();
    dispatch(updateParmsForClass({ sessionId }));
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearClassData());
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`, 
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleModalOpen = (classId) => {
    if (classId) {
      dispatch(getClassRosterData({ classId }));
      setOpenModal(true);
    }
  };

   const handleModalClose = () => {
    setModalTableMapData([]);
    setOpenModal(false);
  };

  function uniqBy(a, key) {
    var seen = {};
    return a.filter(function (item) {
      var k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }

  const getLocalizedClassStatus = (status) => {
    const statusMap = {
      284210000: "available",
      284210001: "full",
      284210002: "waitList",
      284210003: "cancelled",
      284210004: "completed",
      284210005: "closed",
      Available: "available",
      Full: "full",
      "Wait List": "waitList",
      Cancelled: "cancelled",
      Completed: "completed",
      Closed: "closed",
    };
    const statusKey = statusMap[status];
    if (!statusKey) return status || "";
    return (
      localizedStrings.facultyAndStuff.class.statusOptions?.[statusKey] ||
      status ||
      ""
    );
  };

  const getLocalizedGradeOption = (gradeOption) => {
    const gradeMap = {
      true: "grade",
      false: "none",
      Grade: "grade",
      "Pass/Fail": "passFail",
      Audit: "audit",
    };
    const gradeKey = gradeMap[gradeOption];
    if (!gradeKey) return gradeOption === false ? "" : gradeOption || "";
    return (
      localizedStrings.facultyAndStuff.class.gradeOptions?.[gradeKey] ||
      (gradeOption === true ? "Grade" : gradeOption || "")
    );
  };

  const isGradeLinkVisible = (endDate) => {
    if (!endDate) return false;
    const current = new Date();
    const modifiedEndDate = moment(endDate).format("YYYY-MM-DD");
    const end = new Date(modifiedEndDate);
    end.setDate(end.getDate() + 1);
    return current >= end;
  };

  const shouldShowGradesIcon = (section) => {
    if (typeof section !== "string") return true;
    const trimmed = section.trim();
    return !(trimmed.startsWith("B") || trimmed.startsWith("S"));
  };

  useEffect(() => {
    const classRows = classData?.data || [];
    const termRows = terms?.data || [];
    const filterTerms = [];
    if (classRows.length !== 0 && termRows.length !== 0) {
      classRows.forEach((element) => {
        termRows.forEach((term) => {
          if (element.ses_termname === term.ses_termname) {
            filterTerms.push(term);
          }
        });
      });
    }
    const uniqueTerms = uniqBy(filterTerms, JSON.stringify).sort(
      (a, b) => new Date(b.ses_startdate) - new Date(a.ses_startdate),
    );
    setfilterTermsData(uniqueTerms);

    if (classRows.length === 0) {
      setTerms("");
      setTableMapData([]);
      return;
    }

    if (uniqueTerms.length === 0) {
      setTerms("");
      setTableMapData(classRows);
      return;
    }

    const now = new Date();
    const currentTerm = uniqueTerms.find((term) => {
      const start = term.ses_startdate ? new Date(term.ses_startdate) : null;
      const end = term.ses_enddate ? new Date(term.ses_enddate) : null;
      return start && end && start <= now && now <= end;
    });

    const selectedTerm = currentTerm?.ses_termname || uniqueTerms[0]?.ses_termname || "";
    setTerms(selectedTerm);
    setTableMapData(
      classRows.filter((element) => element.ses_termname === selectedTerm),
    );
  }, [terms, classData]);

  let tableData = "";
  let termData = "";
  if (!isObjectEmpty(classData?.data)) {
    if (classData?.data) {
      if (Array.isArray(classData.data)) {
        tableData =
          tableMapData.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_termname}
                      </StyledTableCell>
                      <StyledTableCell>{element.ses_institutionclassid}</StyledTableCell>
                      <StyledTableCell>{element.ses_classname}</StyledTableCell>
                      <StyledTableCell>{element.ses_classcapacity}</StyledTableCell>
                      <StyledTableCell>
                        {element.ses_sessioncount}
                      </StyledTableCell>
                      <StyledTableCell>
                        {getLocalizedClassStatus(element.ses_classstatus)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {shouldShowGradesIcon(element.ses_section) &&
                          (isGradeLinkVisible(element.ses_enddate) ? (
                            <Link
                              to={`/faculty/classgrades?classId=${element.ses_classid}`}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textDecoration: "none",
                                color: "#005598"
                              }}
                            >
                              <MdFactCheck size={24} />
                            </Link>
                          ) : (
                            <Link
                              to={`/faculty/classgrades?classId=${element.ses_classid}`}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textDecoration: "none",
                                color: "#005598"
                              }}
                            >
                              <MdFactCheck size={24} />
                            </Link>
                          ))}
                      </StyledTableCell>
                      <StyledTableCell>
                        <IconButton
                          onClick={() => handleModalOpen(element.ses_classid)}
                        >
                          <MdOutlinePeople />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
        termData = filterTermsData.map((element, index) => (
          <MenuItem value={element.ses_termname} key={index}>
            {element.ses_termname}
          </MenuItem>
        ));
      }
    }
  }

  const handleChange = (event) => {
    const value = event?.target?.value ?? "";
    const copyTableMapData = [...(classData?.data || [])];

    if (value.length === 0) {
      setTableMapData(copyTableMapData);
    } else {
      let copyData = copyTableMapData.filter(
        (element) => element.ses_termname === value,
      );
      setTableMapData(copyData);
    }

    setTerms(value);
  };
  useEffect(() => {
    if (error.message === "No data found!") {
      setDisplayMessage(localizedStrings.general.classerrorMessage);
    } else if (error.message === "No attendance record available") {
      setDisplayMessage(localizedStrings.general.noattendanceMessage);
    } else if (error.message === "Invalid token") {
      setDisplayMessage(localizedStrings.general.invalidToken);
    } else if (
      error.message === "Invalid token or you are missing header token"
    ) {
      setDisplayMessage(localizedStrings.general.invalidTokenandheader);
    } else if (error.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(error.message);
    }
  }, [error]);

  // Custom label for the "of" keyword in TablePagination
  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
       message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Attendance
        open={openModal}
        tableMapData={modalTableMapData}
        onHandleClose={handleModalClose}
      />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <div className={classes.TableControl}>
                  <span>{localizedStrings.facultyAndStuff.class.term}</span>
                  <FormControl className={classes.formControl}>
                    <Select
                      value={termsData}
                      onChange={handleChange}
                      className={classes.formControl}
                      displayEmpty
                    >
                      <MenuItem value="">
                        {localizedStrings.students.classes.table.allTerms}{" "}
                      </MenuItem>
                      {termData}
                    </Select>
                  </FormControl>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.class}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.classname}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.capacity}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.totalenrollment}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.status}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.finalGrade}
              </StyledTableCell>
              <StyledTableCell>
                {localizedStrings.facultyAndStuff.class.roster}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          style={{ textTransform: "capitalize" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData.length > 0 ? tableMapData.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={
            <span style={{ textTransform: "none" }}>
              {localizedStrings.rows.rowsperpage}
            </span>
          }
          labelDisplayedRows={customLabelDisplayedRows}
        />
      </TableContainer>
    </Aux>
  );
}

export default withRouter(PageConatiner);
